// extracted by mini-css-extract-plugin
export default {"header":"SignIn_header__ZShUp","row":"SignIn_row__5edR4","footer":"SignIn_footer__1S0Cn","formFooter":"SignIn_formFooter__NqFuu"};